module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note 5 Pink.40e7411a.png";